import CreateAxiosInstance, { reportApiErrorGlobally } from './axiosConfig';
const APIClient = CreateAxiosInstance(import.meta.env.VITE_API_BASE_URL);

export async function getCodes(searchQuery, page, perPage, sortBy, sortOrder, includeSchoolCodes) {
  return await APIClient.get(`/promo`, {
    params: {
      search_query: searchQuery,
      page: page,
      per_page: perPage,
      sort_by: sortBy,
      sort_order: sortOrder,
      include_school_codes: includeSchoolCodes,
    },
    defaultErrorMessage: 'Error getting promo codes',
  });
}

export async function updateCode(codeId, code) {
  return await APIClient.put(`/promo/${codeId}`, code, {
    defaultErrorMessage: 'Error updating promo code',
  });
}

export async function createCode(code) {
  return await APIClient.post(`/promo`, code, {
    defaultErrorMessage: 'Error creating promo code',
  });
}

export async function lookupRedemptionEmail(messageId) {
  return await APIClient.get(`/promo/redemption-email/${encodeURIComponent(messageId)}`, {
    // 404 (no such Customer.io message) and 502 (Customer.io unreachable) render inline in the modal
    customErrorHandler: () => {},
  });
}

export async function deleteCode(codeId) {
  return await APIClient.delete(`/promo/${codeId}`, {
    defaultErrorMessage: 'Error deleting promo code',
  });
}

export async function redeemCode(code, confirmedSchoolId) {
  return await APIClient.post(
    `/promo/redeem`,
    { promo_code: code, school_record_id: confirmedSchoolId },
    {
      // Errors handled in the component, except the country block, which every caller shows as a modal
      customErrorHandler: (error) => {
        if (error.response?.data?.error_code === 'promo_codes_unavailable') {
          reportApiErrorGlobally(error, null, 'Not available in your country');
        }
      },
    }
  );
}

export async function getRedemptions(
  codeId,
  page = 1,
  perPage = 20,
  sortBy = 'redeemed_at',
  sortOrder = 'desc'
) {
  return await APIClient.get(`/promo/${codeId}/redemptions`, {
    params: { page, per_page: perPage, sort_by: sortBy, sort_order: sortOrder },
    defaultErrorMessage: 'Error getting redemptions',
  });
}

export async function exportRedemptionsCsv(codeId, codeName) {
  const response = await APIClient.get(`/promo/${codeId}/redemptions/export`, {
    responseType: 'blob',
    defaultErrorMessage: 'Error exporting redemptions',
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.download = `${codeName || 'redemptions'}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
